import axios from 'axios';

const API_CLIENT = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

/* ─── Helper: read token from Zustand persisted store ───────────── */
const getStoredToken = () => {
    try {
        const raw = localStorage.getItem('auth-storage');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed?.state?.token || null;
    } catch {
        return null;
    }
};

/* ─── Request interceptor: attach token ─────────────────────────── */
API_CLIENT.interceptors.request.use(
    (config) => {
        const token = getStoredToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

/* ─── Response interceptor: handle errors globally ──────────────── */
API_CLIENT.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            // Network / CORS error — no response received
            console.error('Network Error:', error.message);
            return Promise.reject(new Error('Network error. Please check your internet connection.'));
        }

        const { status } = error.response;

        // 401 = token expired or invalid → clear session and redirect to login
        if (status === 401) {
            try {
                localStorage.removeItem('auth-storage');
            } catch {
                // silently ignore storage errors
            }
            // Redirect to login only if not already there
            if (!window.location.pathname.includes('/login')) {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default API_CLIENT;